(function () {
  function normalizeValue(value) {
    return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function updateMobileStickyOffset(root) {
    var maxBottom = 0;
    var candidates = document.querySelectorAll(
      '[data-sticky-header], #shopify-section-header, .shopify-section-group-header-group, .header-wrapper, header'
    );

    candidates.forEach(function (candidate) {
      var style = window.getComputedStyle(candidate);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;

      var rect = candidate.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top > 8 || rect.height > 240) return;
      maxBottom = Math.max(maxBottom, rect.bottom);
    });

    root.style.setProperty('--compare-mobile-sticky-top', Math.max(0, Math.round(maxBottom)) + 'px');
  }

  function initMobileCompare(root) {
    var mobile = root.querySelector('.compare-models-mobile__comparison');
    if (!mobile) return;

    var highlightToggle = mobile.querySelector('[data-compare-highlight-differences]');
    var specs = Array.prototype.slice.call(mobile.querySelectorAll('[data-compare-mobile-spec]'));

    function updateHighlights() {
      var enabled = Boolean(highlightToggle && highlightToggle.checked);

      specs.forEach(function (spec) {
        var cells = Array.prototype.slice.call(spec.querySelectorAll('[data-compare-mobile-cell]'));
        var counts = {};

        cells.forEach(function (cell) {
          var value = normalizeValue(cell.dataset.compareValue || cell.textContent);
          counts[value] = (counts[value] || 0) + 1;
        });

        spec.classList.toggle('is-highlighting', enabled);
        cells.forEach(function (cell) {
          var value = normalizeValue(cell.dataset.compareValue || cell.textContent);
          cell.classList.toggle('is-duplicate-value', enabled && counts[value] > 1);
        });
      });
    }

    if (highlightToggle) highlightToggle.addEventListener('change', updateHighlights);

    var pair = mobile.querySelector('[data-compare-pair]');
    if (pair) {
      var firstSelect = pair.querySelector('[data-compare-pair-select="first"]');
      var secondSelect = pair.querySelector('[data-compare-pair-select="second"]');
      var differencesToggle = pair.querySelector('[data-compare-pair-differences]');
      var results = pair.querySelector('[data-compare-pair-results]');
      var modelLinks = Array.prototype.slice.call(mobile.querySelectorAll('[data-compare-mobile-header] [data-model-index]'));

      function getModel(index) {
        var link = modelLinks.find(function (item) {
          return item.dataset.modelIndex === String(index);
        });

        return {
          label: link ? link.textContent.trim() + 'W' : String(index),
          url: link ? link.dataset.modelUrl : '#'
        };
      }

      function keepSelectionsDistinct(changedSelect) {
        if (!firstSelect || !secondSelect || firstSelect.value !== secondSelect.value) return;
        var target = changedSelect === firstSelect ? secondSelect : firstSelect;
        var options = Array.prototype.slice.call(target.options);
        var alternative = options.find(function (option) {
          return option.value !== changedSelect.value;
        });
        if (alternative) target.value = alternative.value;
      }

      function renderPair() {
        if (!firstSelect || !secondSelect || !results) return;

        keepSelectionsDistinct(firstSelect);
        var firstIndex = firstSelect.value;
        var secondIndex = secondSelect.value;
        var firstModel = getModel(firstIndex);
        var secondModel = getModel(secondIndex);
        var differencesOnly = Boolean(differencesToggle && differencesToggle.checked);

        results.textContent = '';

        var head = document.createElement('div');
        head.className = 'compare-models-mobile__pair-result-head';

        [firstModel, secondModel].forEach(function (model) {
          var link = document.createElement('a');
          link.href = model.url;
          link.textContent = model.label;
          head.appendChild(link);
        });
        results.appendChild(head);

        specs.forEach(function (spec) {
          var firstCell = spec.querySelector('[data-model-index="' + firstIndex + '"]');
          var secondCell = spec.querySelector('[data-model-index="' + secondIndex + '"]');
          if (!firstCell || !secondCell) return;

          var firstValue = firstCell.dataset.compareValue || firstCell.textContent.trim();
          var secondValue = secondCell.dataset.compareValue || secondCell.textContent.trim();
          if (differencesOnly && normalizeValue(firstValue) === normalizeValue(secondValue)) return;

          var row = document.createElement('section');
          row.className = 'compare-models-mobile__pair-result-row';

          var title = document.createElement('h4');
          var sourceTitle = spec.querySelector('.compare-mobile-spec__title');
          title.textContent = sourceTitle ? sourceTitle.textContent.trim() : '';
          row.appendChild(title);

          var values = document.createElement('div');
          values.className = 'compare-models-mobile__pair-result-values';
          [firstValue, secondValue].forEach(function (value) {
            var span = document.createElement('span');
            span.textContent = value;
            values.appendChild(span);
          });
          row.appendChild(values);
          results.appendChild(row);
        });
      }

      if (firstSelect) {
        firstSelect.addEventListener('change', function () {
          keepSelectionsDistinct(firstSelect);
          renderPair();
        });
      }

      if (secondSelect) {
        secondSelect.addEventListener('change', function () {
          keepSelectionsDistinct(secondSelect);
          renderPair();
        });
      }

      if (differencesToggle) differencesToggle.addEventListener('change', renderPair);
      pair.addEventListener('toggle', function () {
        if (pair.open) renderPair();
      });
      renderPair();
    }

    var stickyFrame = 0;
    function queueStickyUpdate() {
      if (stickyFrame) return;
      stickyFrame = window.requestAnimationFrame(function () {
        stickyFrame = 0;
        updateMobileStickyOffset(root);
      });
    }

    updateMobileStickyOffset(root);
    window.addEventListener('resize', queueStickyUpdate, { passive: true });
    window.addEventListener('scroll', queueStickyUpdate, { passive: true });
  }

  function initCompare(root) {
    if (!root || root.dataset.siokiuuCompareReady === 'true') return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-compare-item]'));
    var cells = Array.prototype.slice.call(root.querySelectorAll('[data-compare-column]'));

    if (items.length && cells.length) {
      function setActive(index) {
        items.forEach(function (item) {
          var active = item.dataset.compareIndex === index;
          item.classList.toggle('is-active', active);
          item.classList.toggle('is-featured', active);
        });

        cells.forEach(function (cell) {
          cell.classList.toggle('is-highlight', cell.dataset.compareColumn === index);
        });

        root.dataset.activeCompareIndex = index;
      }

      items.forEach(function (item) {
        var index = item.dataset.compareIndex;

        item.addEventListener('mouseenter', function () {
          setActive(index);
        });

        item.addEventListener('focusin', function () {
          setActive(index);
        });

        item.addEventListener('click', function (event) {
          if (event.target.closest('a, button')) return;
          setActive(index);
        });

        item.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          if (event.target.closest('a, button')) return;
          event.preventDefault();
          setActive(index);
        });
      });

      var activeItem = root.querySelector('[data-compare-item].is-active') || items[0];
      setActive(activeItem.dataset.compareIndex);
    }

    initMobileCompare(root);
    root.dataset.siokiuuCompareReady = 'true';
  }

  function initAllCompareSections() {
    document.querySelectorAll('[data-siokiuu-compare]').forEach(initCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCompareSections);
  } else {
    initAllCompareSections();
  }

  document.addEventListener('shopify:section:load', initAllCompareSections);
})();
